import {ContainerNull,Container,ContainerLojas,Titulo,AreaHeader,AreaPesquisa,ButtonNovo,ContainerTabela,Tabela,Thead,TR,TH,Tbody,TD,SpanStatus,ButtonEditar,ModalFundo,ModalContainer,ModalHeader,ModalTitulo,ModalFechar,ModalConteudo} from './estilo';
import { useState,useContext,useEffect, useRef, useCallback } from 'react';
import api from '../../../services/api';
import { AuthContext } from '../../../contexts/auth';
import { toast } from 'react-toastify';
import AlteraLoja from '../../modals/Editar_loja';
import InputPesquisa from '../../InputPesquisa';
import InserirLoja from '../../modals/Novo_loja';
import {IoAlertCircleOutline} from 'react-icons/io5';
import RelatorioLink from '../../RelatorioLink';
import UploadXlsx from '../../UploadXlsx';
import { baixarPlanilha } from '../../../utils/planilha/baixarPlanilha';

export default function Lojasdash(){
    const [modal,setModal] = useState(false);
    const [modalNovo,setModalNovo] = useState(false);
    const [modalAtualizarPrecos, setModalAtualizarPrecos] = useState(false);
    const [precosInvalidos, setPrecosInvalidos] = useState([]);
    const [dadosLoja, setDadosLoja] = useState('');
    const {user,signOut} = useContext(AuthContext);
    const [loading,setLoading] = useState(false);
    const [lojas,setLojas] = useState([]);
    const [listaDeLojas, setListaDeLojas] = useState([]);
    const lojasFields = ['id','nome','centroCusto','varejo','dataAbertura','liderSenior','telefoneS','liderDistrital','telefoneD','cnpj','endereco','bairro','cep','cidade','estado','status','createdAt','updatedAt']
    const componentMounted = useRef(true); 

    //busca todas as lojas
    const buscaLojas = useCallback(() => {
        setLoading(true)
        api.get('/lojas',
            {
                headers:{
                    'Authorization':user.token
                }
            }
        )
        .then((resp)=>{
            setLojas(resp.data.lojas)
            setListaDeLojas(resp.data.lojas)
            setLoading(false)
        })
        .catch((error)=>{
            if(error.response.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.error(error.response.data.error)
                setLoading(false)
            }
        })
    },[user.token, signOut]);

    useEffect(()=>{
        if (componentMounted.current){ 
            buscaLojas()
        }
        return () => {
            componentMounted.current = false;
        }
    },[buscaLojas])

    function enviaDados(item){
        setModal(!modal)
        setDadosLoja(item)
    }

    function abreNovo(){
        setModalNovo(!modalNovo);
    }

    function atualizarPrecos(){
        if(modalAtualizarPrecos){
            setPrecosInvalidos([]);
        }
        setModalAtualizarPrecos(!modalAtualizarPrecos);
    }

    function baixarModeloAtualizacaoPrecos(){
        baixarPlanilha({
            nomeDoArquivo: 'modelo_atualizacao_precos_lojas.xlsx',
            abas: [{
                nome: 'atualizacao_precos',
                dados: [{
                    loja_id: '',
                    preco_selecionado: ''
                }]
            }]
        });
    }

    async function enviarAtualizacaoPrecos(results){
        const lojas = results?.data || [];
        setPrecosInvalidos([]);

        if(!lojas.length){
            return toast.error('Adicione lojas para enviar.');
        }

        try {
            await api.patch('/lojas/alterarPreco',
                { lojas },
                {
                    headers: { 'Authorization': user.token },
                }
            );

            toast.success('Precos das lojas atualizados com sucesso');
            setModalAtualizarPrecos(false);
            setPrecosInvalidos([]);
            buscaLojas();
        } catch (error) {
            if(error?.response?.status === 401){
                signOut();
            }

            if (error?.response?.data?.messages){
                const erros = error.response.data.messages;
                erros.forEach((erro) => toast.error(erro));
                return;
            }

            if (error?.response?.data?.precos_invalidos?.length){
                setPrecosInvalidos(error.response.data.precos_invalidos);
            }

            toast.error(error?.response?.data?.error || 'Erro ao atualizar precos das lojas');
        }
    }

    function filtroDeLojas(lista, valor){
        return lista.filter((loja) => loja.nome.toUpperCase().includes(valor.toUpperCase()) || loja.centroCusto.includes(valor));
    }

    if(loading){
        return(
            <Container>
                <ContainerLojas>
                    <Titulo>Carregando...</Titulo>
                </ContainerLojas>
            </Container>
        )
    }
    return(
        <Container>
            <ContainerLojas>
                <Titulo>LISTA DE LOJAS</Titulo>
                <AreaHeader>
                    <AreaPesquisa>
                        <InputPesquisa lista={lojas} setLista={setListaDeLojas} funcaoDeFiltro={filtroDeLojas}/>
                    </AreaPesquisa>
                    <ButtonNovo onClick={abreNovo}>
                        Novo
                    </ButtonNovo>
                    <ButtonNovo className='botao' onClick={atualizarPrecos}>
                        Atualizar Preços
                    </ButtonNovo>
                    <RelatorioLink dados={listaDeLojas} fields={lojasFields} filename={"lojas"}/>
                </AreaHeader>
                {listaDeLojas.length === 0 ? (
                        <ContainerNull>
                            <IoAlertCircleOutline size={50} color='#FF0000'/>
                            <h1>Nenhum item encontrado...</h1>
                        </ContainerNull>
                    ) :
                    (
                        <ContainerTabela>
                            <Tabela>
                                <Thead>
                                    <TR>
                                        <TH scope='col'>Id</TH>
                                        <TH scope='col'>Loja</TH>
                                        <TH scope='col'>Centro de Custo</TH>
                                        <TH scope='col'>Varejo</TH>
                                        <TH scope='col'>Data de Abertura</TH>
                                        <TH scope='col'>Status</TH>
                                        <TH scope='col'>fornecedor</TH>
                                        <TH scope='col'>#</TH>
                                    </TR>
                                </Thead>
                                    <Tbody>
                                            {listaDeLojas.map((loja)=>{
                                                    return(
                                                        
                                                            <TR key={loja.id}>
                                                                <TD data-label='id'>{loja.id}</TD>
                                                                <TD data-label='loja'>{loja.nome}</TD>
                                                                <TD data-label='centroCusto'>{loja.centroCusto}</TD>
                                                                <TD data-label='varejo'>{loja.varejo}</TD>
                                                                <TD data-label='dataAbertura'>{loja.dataAbertura === '' ? 'Sem cadastro' : loja.dataAbertura}</TD>
                                                                <TD data-label='status'>
                                                                    <SpanStatus style={{backgroundColor:loja.status === 'ATIVO' ? '#29C013' : '#FF0000' }}>{loja.status}</SpanStatus>
                                                                </TD>
                                                                <TD data-label='fornecedor'>{loja.fornecedor}</TD>
                                                                <TD data-label='#'>
                                                                    <ButtonEditar onClick={()=> enviaDados(loja)}>
                                                                        EDITAR
                                                                    </ButtonEditar>
                                                                </TD>
                                                            </TR>
                                                    
                                                        
                                                    )
                                                }
                                            )
                                            }
                                    </Tbody>
                            </Tabela>
                        </ContainerTabela>
                    )
                }
                {modal && (
                    <AlteraLoja
                    conteudo={dadosLoja}
                    fechar={enviaDados}
                    atualizaLojas={buscaLojas}
                    />
                    )
                }
                {
                modalNovo && (
                    <InserirLoja
                    fechar={abreNovo}
                    atualizaLojas={buscaLojas}
                    />
                )
                }
                {modalAtualizarPrecos && (
                    <ModalFundo>
                        <ModalContainer>
                            <ModalHeader>
                                <ModalTitulo>ATUALIZAR PREÇOS DAS LOJAS</ModalTitulo>
                                <ModalFechar onClick={atualizarPrecos}>X</ModalFechar>
                            </ModalHeader>
                            <ModalConteudo>
                                <div className='upload-container'>
                                    <UploadXlsx
                                        resultCallback={enviarAtualizacaoPrecos}
                                        onDownloadTemplate={baixarModeloAtualizacaoPrecos}
                                        downloadLabel="BAIXAR MODELO"
                                    />
                                </div>
                                    {precosInvalidos.length > 0 && (
                                        <div style={{marginBottom: '12px'}}>
                                            <h4 style={{color: '#B00020', marginBottom: '6px'}}>Preços inválidos encontrados:</h4>
                                            <ul style={{marginLeft: '20px'}}>
                                                {precosInvalidos.map((precoInvalido, index) => (
                                                    <li key={`${precoInvalido}-${index}`}>{precoInvalido}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                            </ModalConteudo>
                        </ModalContainer>
                    </ModalFundo>
                )}
            </ContainerLojas>
        </Container>
    )
}